import { ProductKind } from "./product-kind";

class PriceDTO {
	public net: number;
	public gross: number;
	public currencyId: number;
}

class OssVatRateDTO {
	public countryId: number;
	public vatRateId: number;
}

export class ProductDTO {
	public active?: boolean;
	public inventoryControl: boolean;
	public inventoryLevel?: number;
	public cnCode: string | null;
	public description: string;
	public favourite: boolean;
	public fiscalName: string;
	public groupId?: string | null;
	public jpkVatGroups: string[];
	public id: number;
	public externalId?: string;
	public kind: ProductKind;
	public name: string;
	public pkwiu: string | null;
	public prices: PriceDTO[];
	public ossVatRates: OssVatRateDTO[];
	public subjectToReverseCharge: boolean;
	public offers: string[];
	public unitId: number;
	public vatRateId: number;
	public version: string;
	public purchasePrice: PriceDTO | null;
	public purchaseVatRateId?: number;
	public inventoryWarningLevel?: number;
	public barCode?: string;
	public symbol?: string;
    public productsAssociated?: string[];
}
